import React, { useState, useEffect , useRef } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import Letter_actions from "./Letter_actions";

const Exportpopup = (props) => {
    const {show , setshow,id , date_of_joining} = props;
    const handleClose =()=>{
setshow(false)
    }
  return (
    <>
          <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{width:"55%"}}>
            <div className="asds">
                   <div class="ModalHeader">
                    <span className="UserCreate"> Exports </span>

                                <div
                                  className="CloseIcon"
                                  onClick={(e) => {
                                    handleClose(e);
                                  }}
                                >
                                  <CloseOutlinedIcon />
                                </div>
                              </div>
                
            </div>

              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  padding: "0px 15px 0px 0px",
                  marginBottom: "38px",
                  marginTop:"20px",
                  alignItems: "center",
                  flexWrap:"wrap"

                }}
              >
<Letter_actions setshow ={setshow} user_id={id} date_of_joining={date_of_joining}/>

              </div>

            </div>
          </div>
        </div>




    </>
  )
}

export default Exportpopup
 